import { render, staticRenderFns } from "./UsersCardPage.vue?vue&type=template&id=0c299e1c"
import script from "./UsersCardPage.vue?vue&type=script&lang=js"
export * from "./UsersCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports